import axios from 'axios';
import { useToast } from '../composables/useToast.js';

// Get toast instance
const { handleAxiosError } = useToast();

axios.interceptors.response.use((response) => response, (error) => {
    if (error.response?.status === 401) {
        window.location.href = `/login?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search + window.location.hash)}`;
    }
    if (error.response?.status === 500) {
        // Use toast notification system for Vue 3
        if (!error.handledGlobally) {
            handleAxiosError(error);
            error.handledGlobally = true;
        }
    }
    return Promise.reject(error);
});

export default axios;